/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normality is the concentration expressed as gram-equivalents of reactive species per litre. It equals molarity multiplied by the number of equivalents per mole (protons for an acid, hydroxides for a base, electrons for a redox agent).`)
};

const es_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La normalidad es la concentración expresada como equivalentes-gramo de especie reactiva por litro. Es igual a la molaridad multiplicada por el número de equivalentes por mol (protones para un ácido, hidróxidos para una base, electrones para un agente redox).`)
};

const de_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalität ist die Konzentration ausgedrückt als Grammäquivalente reaktiver Spezies pro Liter. Sie entspricht der Molarität multipliziert mit der Anzahl der Äquivalente pro Mol (Protonen bei einer Säure, Hydroxide bei einer Base, Elektronen bei einem Redoxmittel).`)
};

const nl_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliteit is de concentratie uitgedrukt als gram-equivalenten reactieve stof per liter. Het is gelijk aan molariteit vermenigvuldigd met het aantal equivalenten per mol (protonen voor een zuur, hydroxides voor een base, elektronen voor een redoxmiddel).`)
};

const fr_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La normalité est la concentration exprimée en équivalents-grammes d'espèces réactives par litre. Elle est égale à la molarité multipliée par le nombre d'équivalents par mole (protons pour un acide, hydroxydes pour une base, électrons pour un agent redox).`)
};

const it_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La normalità è la concentrazione espressa come grammo-equivalenti di specie reattiva per litro. Equivale alla molarità moltiplicata per il numero di equivalenti per mole (protoni per un acido, idrossidi per una base, elettroni per un agente redox).`)
};

const pt_br2_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidade é a concentração expressa como equivalentes-grama de espécie reativa por litro. Ela é igual à molaridade multiplicada pelo número de equivalentes por mol (prótons para um ácido, hidroxilas para uma base, elétrons para um agente redox).`)
};

const pt_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A normalidade é a concentração expressa em equivalentes-grama de espécie reativa por litro. É igual à molaridade multiplicada pelo número de equivalentes por mole (protões para um ácido, hidróxidos para uma base, eletrões para um agente redox).`)
};

const ja_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規定度は、1リットルあたりの反応種のグラム当量として表される濃度です。モル濃度に1モルあたりの当量数（酸ではプロトン数、塩基では水酸化物イオン数、酸化還元剤では電子数）を掛けたものに等しくなります。`)
};

const zh_norm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量浓度是以每升反应物质的克当量数表示的浓度。它等于摩尔浓度乘以每摩尔的当量数（酸的质子数、碱的氢氧根数，或氧化还原剂的电子数）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_a1", locale)
	if (locale === "en") return en_norm_faq_a1(inputs)
	if (locale === "es") return es_norm_faq_a1(inputs)
	if (locale === "de") return de_norm_faq_a1(inputs)
	if (locale === "nl") return nl_norm_faq_a1(inputs)
	if (locale === "fr") return fr_norm_faq_a1(inputs)
	if (locale === "it") return it_norm_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_a1(inputs)
	if (locale === "pt") return pt_norm_faq_a1(inputs)
	if (locale === "ja") return ja_norm_faq_a1(inputs)
	return zh_norm_faq_a1(inputs)
};